import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { AllSkusResponseModel } from '@/types/clarityLens'

export const getAllSkus = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemName: string
): Promise<AllSkusResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/spend-lens/item/price-history/all-skus`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          dcn: branchName,
          item_name: itemName,
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
